import { IFileInputControl } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import {
  FileInputFormControlViewModel,
  FormControlViewModelType,
  LocalizedProps,
} from '../../view-model/FormControlViewModel';
import { FormSourceType } from '../../view-model/FormSource';
import { FormViewModel } from '../../view-model/FormViewModel';

import { getValueFromArgsOrConfig } from './helpers';

const buildFileInputControl = async (
  viewModel: FormViewModel,
  item: IFileInputControl,
  localizedProps: LocalizedProps,
  args: TActionArgsValues
): Promise<FileInputFormControlViewModel> => ({
  accept: item.accept,
  hasValue: true,
  hasHistory: false,
  columns: item.columns,
  noLabel: item.noLabel,
  type: FormControlViewModelType.FILE,
  labelWidth: item.labelWidth,
  name: item.name,
  disabled: item.disabled,
  visible: item.visible,
  value: getValueFromArgsOrConfig<File | null>(
    item,
    args,
    viewModel.source,
    null
  ),
  required: item.required,
  storeValue: item.storeValue,
  readonly: item.readonly || viewModel.source.type === FormSourceType.REVIEW,
  enableButtonOnReadOnly: viewModel.source.type !== FormSourceType.REVIEW,
  ...localizedProps,
});

export default buildFileInputControl;
